// react
import React from "react";

const CheckoutSkeleton = () => {
    return (
        <div className="checkout-container">
            <div className="checkout-section checkout-items-section">
                <div className="skeleton-title"></div>
                <div className="basket-items-list">
                    {[1, 2, 3].map((item) => (
                        <div key={item} className="skeleton-card">
                            <div className="skeleton-card-content">
                                <div className="skeleton-text skeleton-title-small"></div>
                                <div className="skeleton-text skeleton-medium"></div>
                                <div className="skeleton-text skeleton-short"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="checkout-section checkout-summary-section">
                <div className="checkout-summary-content">
                    <div className="checkout-summary-info">
                        <div className="skeleton-title-small"></div>
                        <div className="checkout-info-rows">
                            {[1, 2, 3].map((item) => (
                                <div key={item} className="checkout-info-row">
                                    <div className="skeleton-text skeleton-label"></div>
                                    <div className="skeleton-text skeleton-value"></div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="checkout-summary-taxes">
                        <div className="skeleton-title-small"></div>
                        <div className="checkout-tax-summary">
                            {[1, 2, 3].map((item) => (
                                <div key={item} className="checkout-tax-row">
                                    <div className="skeleton-text skeleton-short"></div>
                                    <div style={{ display: "flex", gap: "1rem" }}>
                                        <div className="skeleton-text skeleton-short"></div>
                                        <div className="skeleton-text skeleton-short"></div>
                                        <div className="skeleton-text skeleton-short"></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="checkout-section checkout-payment-section">
                <div className="skeleton-button"></div>
            </div>
        </div>
    );
};

export default CheckoutSkeleton;

